import React from 'react';
import PropTypes from 'prop-types';
import RightPaneContentTabs from '../right-pane/right-pane-content-tabs';

export const SenderDetailsContentTabs = ( { handleTabChange, tabIndex } ) => {
    const tabData = [
        {
            dataAutomationId: 'sender-details-profile-tab',
            label: 'Profile',
        },
        {
            dataAutomationId: 'sender-details-domain-tab',
            label: 'Domains',
        },
        {
            dataAutomationId: 'sender-details-general-tab',
            label: 'General',
        }
    ];

    return (
        <RightPaneContentTabs
            handleTabChange={handleTabChange}
            tabData={tabData}
            tabIndex={tabIndex}
        />
    );
};

SenderDetailsContentTabs.propTypes = {
    handleTabChange: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired
};

export default SenderDetailsContentTabs;
